import { ShippingTypeEnum } from '@app/marketplace/core/enum/shippingType';
import {createAction,props} from '@ngrx/store';
import { ProductAttribute } from '../../_models/product.interface';
export const LOADING_PRODUCT_DETAILS = '[PRODUCT-DETAILS] Loading products details';
export const LOADING_PRODUCT_DETAILS_DLG = '[PRODUCT-DETAILS-DLG] Loading products details';
export const GET_PRODUCT_DETAILS = '[PRODUCT-DETAILS] Get Product details';
export const SET_SHIPPINGTYPE= '[PRODUCT-DETAILS] Set Shipping Type';
export const SET_ACTIVEATTRIBUTEVALUE= '[PRODUCT-DETAILS] Set Active Attribute Value';
export const SET_ERROR= '[PRODUCT-DETAILS] Set Error';
export const ERROR_PRODUCTS_DETAILS  = '[PRODUCT-DETAILS] Products details loaded Error';
export const CANCEL_PRODUCTS_DETAILS_REQUEST = '[PRODUCT-DETAILS] Cancel products details request';
export const INCREASE_QUANTITY_DETAILS = '[PRODUCT-DETAILS] Increase  quantity';
export const REDUCE_QUANTITY_DETAILS = '[PRODUCT-DETAILS] Reduce quantity';
export const RESET_QUANTITY_DETAILS = '[PRODUCT-DETAILS] Reset quantity';

export const LoadingProductDetailAction = createAction(LOADING_PRODUCT_DETAILS);
export const LoadingProductDetailDlgAction = createAction(
  LOADING_PRODUCT_DETAILS_DLG,
  props<{code: string,provider:number}>()
);
export const ProductDetailsAction = createAction(
  GET_PRODUCT_DETAILS,
  props<{data: any}>()
);
export const SetShippingType= createAction(
  SET_SHIPPINGTYPE,
  props<{shippingType:ShippingTypeEnum}>()
);

export const SetActiveAttributeValue = createAction(
  SET_ACTIVEATTRIBUTEVALUE,
  props<{
    attr:ProductAttribute,
    active:boolean}>()
);

export const SetError= createAction(
  SET_ERROR,
  props<{message:string}>()
);
export const CancelProductDetailsRequestAction = createAction(CANCEL_PRODUCTS_DETAILS_REQUEST);
export const ErrorProductDetailsActions = createAction(ERROR_PRODUCTS_DETAILS);
export const IncreaseQuantityAction = createAction(INCREASE_QUANTITY_DETAILS);
export const ReduceQuantityAction = createAction(REDUCE_QUANTITY_DETAILS);
export const ResetQuantityAction = createAction(RESET_QUANTITY_DETAILS);
